var render, staticRenderFns
import script from "./ServiceWorkerUpdatePopup.vue?vue&type=script&lang=ts"
export * from "./ServiceWorkerUpdatePopup.vue?vue&type=script&lang=ts"
import style0 from "./ServiceWorkerUpdatePopup.vue?vue&type=style&index=0&id=0bdfe40f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdfe40f",
  null
  
)

export default component.exports